import React, { useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

/** Pages */
import Home from './pages/Home';
import Shadow from './pages/Shadow';
import Border from './pages/Border';

/** Componentes */
import Layout from './components/Layout';

/** Icons */
import { ReactComponent as Light } from './assets/svg/zap.svg';
import { ReactComponent as LightOff } from './assets/svg/zap-off.svg';

function App() {
  const [dark, setDark] = useState(true);

  const switchTheme = () => {
    setDark(!dark);
  };

  const bg = dark ? 'bg-gray-800' : 'bg-gray-200';

  return (
    <div className={`${bg} max-h-screen h-screen flex flex-col justify-between`}>
      <Router basename='/css-utilities/'>
        <Layout>
          <div
            onClick={() => switchTheme()}
            className={`rounded shadow-lg flex items-center justify-center w-16 h-16 fixed ${window.innerWidth > 770 ? "right-0 mr-16" : "left-0 ml-10"}  mt-10 ${dark ? 'bg-indigo-900 text-white' : 'bg-white text-indigo-900'}`}
          >
            {dark && <Light />}
            {!dark && <LightOff />}
          </div>
          <Switch>
            <Route path="/border-radius">
              <Border dark={dark} />
            </Route>
            <Route path="/box-shadow">
              <Shadow dark={dark} />
            </Route>
            <Route exact path="/">
              <Home dark={dark} />
            </Route>
          </Switch>
        </Layout>
      </Router>
    </div>
  );
}

export default App;
